import styled from 'styled-components';

interface CheckboxInputProps {
  id?: string;
  isChecked: boolean;
  value?: string;
  onChange?: () => void;
}

export const CheckboxInput = ({ id, isChecked, value, onChange }: CheckboxInputProps) => {
  return <Input id={id} type={'checkbox'} value={value} checked={isChecked} onChange={onChange} />;
};

const Input = styled.input`
  width: 16px;
  height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 8px;

  border-radius: var(--radius-small, 4px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey30, #d5d5e3);
  background: var(--Light-Scheme-Monochrome-white, #fff);

  cursor: pointer;
`;
